/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum AccountStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export interface AutoRollCycleSummaryDto {
  outcome: string | null;
  skipReason?: string | null;
  /** @format date-time */
  closedAt?: string | null;
}

export interface AutoRollInstructionDto {
  id: string | null;
  treasuryBillId: string | null;
  title: string | null;
  isin: string | null;
  /** @format date */
  maturityDate?: string;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  tenorWeeks?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  cycleCount?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  faceValue?: any;
  status: string | null;
  isDormant?: boolean;
  dormantReason?: string | null;
  lastCycle?: AutoRollCycleSummaryDto | null;
}

export enum CashFlowType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
}

export interface ClientFeeDto {
  id?: string | null;
  corporateClientId?: string | null;
  /** @format date-time */
  feeTimestamp?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  amount?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  rate?: any;
  feeType?: string | null;
  description?: string | null;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  baseBlanketValue?: any;
  calculationMethod?: string | null;
  relatedISIN?: string | null;
  relatedAssetId?: string | null;
}

export interface CompleteMfaLoginCommand {
  challengeId?: string | null;
  code?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export interface ConfirmPasswordResetCommand {
  email?: string | null;
  token?: string | null;
  newPassword?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export interface CorporateClientSummaryDto {
  id?: string | null;
  name?: string | null;
  registrationNumber?: string | null;
  type?: CorporateClientType;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  chargeRatePerAnnum?: any;
}

export enum CorporateClientType {
  Value0 = 0,
  Value1 = 1,
}

export interface CorporateEntityDto {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  address?: string | null;
  /** @format date */
  dateEstablished?: string;
  taxIdentificationNumber?: string | null;
  registrationNumber?: string | null;
  countryOfIncorporation?: string | null;
  virtualCashAccount?: VirtualCashAccountDto;
}

export interface CreateTreasuryBillSellOrderCommand {
  assetId?: string | null;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  amount?: any;
}

export enum Currency {
  Value0 = 0,
}

export interface DepositDetailsDto {
  accountName?: string | null;
  accountNumber?: string | null;
  sortCode?: string | null;
  bankAddress?: string | null;
  referenceNumber?: string | null;
  currency?: string | null;
}

export enum EmailVerificationFailureReason {
  NotFound = 'NotFound',
  Expired = 'Expired',
  InvalidCode = 'InvalidCode',
  TooManyAttempts = 'TooManyAttempts',
  NotVerified = 'NotVerified',
  VerificationExpired = 'VerificationExpired',
  AlreadyUsed = 'AlreadyUsed',
}

export enum FeeType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

export interface ForgotPasswordCommand {
  email?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export interface ForgotPasswordResponse {
  success?: boolean;
  message?: string | null;
}

export interface InvestorDailyBalanceDto {
  id?: string | null;
  corporateClientId?: string | null;
  /** @format date-time */
  balanceTimestamp?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  availableCash?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  reservedCash?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  totalCash?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  totalAssetValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  pendingIncomingSettlement?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  totalPortfolioValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  lifetimeEarnings?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  cashLedgerBalance?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  feesPayableBalance?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  cashPayableToCustodianBalance?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  numberOfPositions?: any;
  /** @format date-time */
  calculationTimestamp?: string;
}

export enum Issuer {
  Value0 = 0,
}

export interface IssuerDto {
  code?: string | null;
}

export interface LoginResponse {
  success?: boolean;
  error?: string | null;
  requiresMfa?: boolean;
  mfaChallengeId?: string | null;
  mfaMethod?: string | null;
  token?: string | null;
  refreshToken?: string | null;
  email?: string | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  remainingAttempts?: any;
  /** @format date-time */
  lockedUntil?: string | null;
}

export interface LoginUserCommand {
  email?: string | null;
  password?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export enum MaturityAge {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export enum OrderStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export interface PaginatedListOfClientFeeDto {
  items: ClientFeeDto[] | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  pageNumber: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalPages?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalCount?: any;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface PaginatedListOfPositionSnapshotDto {
  items: PositionSnapshotDto[] | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  pageNumber: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalPages?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalCount?: any;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface PaginatedListOfRecentTransactionDto {
  items: RecentTransactionDto[] | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  pageNumber: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalPages?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalCount?: any;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface PaginatedListOfTreasuryBillListingDto {
  items: TreasuryBillListingDto[] | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  pageNumber: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalPages?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalCount?: any;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface PaginatedListOfTreasuryBillSummaryDto {
  items: TreasuryBillSummaryDto[] | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  pageNumber: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalPages?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  totalCount?: any;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export enum PasswordResetFailureReason {
  InvalidToken = 'InvalidToken',
  ExpiredToken = 'ExpiredToken',
  TokenAlreadyUsed = 'TokenAlreadyUsed',
  UserNotFound = 'UserNotFound',
}

export interface PositionSnapshotDto {
  id?: string | null;
  corporateClientId?: string | null;
  treasuryBillId?: string | null;
  /** @format date-time */
  snapshotTimestamp?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  ledgerOriginalValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  ledgerAccruedInterest?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  ledgerTotalValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  marketValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  marketYieldToMaturity?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  faceValue?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  daysToMaturity?: any;
  isMatured?: boolean;
  isin?: string | null;
  title?: string | null;
  /** @format date */
  maturityDate?: string;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  status?: any;
  detail?: string | null;
  instance?: string | null;
}

export interface ProfilePreferencesDto {
  theme: string | null;
  notifications?: boolean;
}

export interface ProfileWithCorporateEntitiesDto {
  corporateEntities?: CorporateClientSummaryDto[] | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  avatarUrl?: string | null;
  status?: AccountStatus;
  preferences?: ProfilePreferencesDto | null;
}

export interface RecentTransactionDto {
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  amount?: any;
  isDebit?: boolean;
  description?: string | null;
  /** @format date-time */
  transactionDate?: string;
  isin?: string | null;
}

export interface ReconfigureAutoRollCommand {
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  tenorWeeks?: any;
}

export enum RefreshFailureReason {
  Unknown = 'unknown',
  Expired = 'expired',
  IdleTimeout = 'idle_timeout',
  ReplayDetected = 'replay_detected',
  SessionSuperseded = 'session_superseded',
}

export interface RegisterUserAccountCommand {
  userName?: string | null;
  password?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  businessName?: string | null;
  position?: string | null;
  companyNumber?: string | null;
  challengeId?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export interface RegisterUserAccountResponse {
  userId?: string | null;
  requiresEmailVerification?: boolean;
  verificationChallengeId?: string | null;
  /** @format date-time */
  verificationExpiresAt?: string | null;
  message?: string | null;
}

export interface RequestTreasuryBillCommand {
  treasuryBillListingId?: string | null;
  corporateEntityId?: string | null;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  requestedPurchasePrice?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  faceValue?: any;
  autoRoll?: boolean | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  autoRollTenorWeeks?: any;
  /** @format uuid */
  replacesAutoRollInstructionId?: string | null;
}

export interface RequestWithdrawalCommand {
  corporateClientId?: string | null;
  withdrawalBankAccountId?: string | null;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  amount?: any;
}

export interface ResendVerificationEmailCommand {
  email?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export interface ResendVerificationEmailResponse {
  challengeId?: string | null;
  success?: boolean;
  message?: string | null;
  /** @format date-time */
  resendAllowedAt?: string | null;
}

export interface ResetPasswordResponse {
  success?: boolean;
  reason?: PasswordResetFailureReason | null;
  message?: string | null;
}

export interface SendVerificationEmailCommand {
  email?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export interface SendVerificationEmailResponse {
  success?: boolean;
  challengeId?: string | null;
  /** @format date-time */
  expiresAt?: string | null;
}

export interface TokenResult {
  token?: string | null;
  success?: boolean;
  errorCode?: RefreshFailureReason | null;
  errorMessage?: string | null;
}

export enum TransactionType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
}

export interface TreasuryBillDto {
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  treasuryBillListingId?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  faceValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  originalFaceValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  requestedPurchasePrice?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  snapshotYieldToMaturity?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  snapshotPricePer100FaceValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  dealerQuotedYieldPercent?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  yieldToMaturity?: any;
  issuer?: IssuerDto;
  /** @format date */
  maturityDate?: string;
  isOrder?: boolean;
  isAsset?: boolean;
  isMatured?: boolean;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  daysToMaturity?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  pendingSaleAmount?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  pendingSaleCount?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  completedPartialSaleCount?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  saleProceeds?: any;
  isSettled?: boolean;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  currentEstimatedValue?: any;
  treasuryBillListing: TreasuryBillListingNestedDto;
  transactions?: TreasuryBillTransactionDto[] | null;
  id?: string | null;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  pricePaid?: any;
  title?: string | null;
  isin?: string | null;
  status?: OrderStatus;
  /** @format date-time */
  orderDateTimeUTC?: string;
}

export interface TreasuryBillListingDto {
  /** @format date */
  issueDate?: string;
  /** @format date */
  maturityDate?: string;
  /** @format date */
  auctionDate?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  marketYieldToMaturity?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  pricePer100FaceValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  midPricePer100FaceValue?: any;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  timeToMaturityInDays?: any;
  isMatured?: boolean;
  id?: string | null;
  title?: string | null;
  isin?: string | null;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  maxAvailableFaceValue?: any;
  issuer?: Issuer;
}

export interface TreasuryBillListingNestedDto {
  publicId?: string | null;
  title?: string | null;
  isin?: string | null;
  issuer?: IssuerDto;
  /** @format date */
  maturityDate?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  pricePer100FaceValue?: any;
}

export interface TreasuryBillSummaryDto {
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  currentEstimatedValue?: any;
  /** @format date */
  maturityDate?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  faceValue?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  yield?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  dealerQuotedYieldPercent?: any;
  treasuryBillListingId: string | null;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  saleProceeds?: any;
  isSettled?: boolean;
  id?: string | null;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  pricePaid?: any;
  title?: string | null;
  isin?: string | null;
  status?: OrderStatus;
  /** @format date-time */
  orderDateTimeUTC?: string;
}

export interface TreasuryBillTransactionDto {
  id?: string | null;
  treasuryBillId?: string | null;
  transactionType?: TransactionType;
  /** @format date-time */
  transactionDateTime?: string;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  amount?: any;
  notes?: string | null;
  transactionTypeDisplay?: string | null;
  transactionDescriptionDisplay?: string | null;
}

export interface VerifyUserAccountEmailCommand {
  challengeId?: string | null;
  code?: string | null;
  ipAddress?: string | null;
  userAgent?: string | null;
}

export interface VerifyUserAccountEmailResponse {
  success?: boolean;
  reason?: EmailVerificationFailureReason | null;
  error?: string | null;
  message?: string | null;
  /**
   * @format int32
   * @pattern ^-?(?:0|[1-9]\d*)$
   */
  remainingAttempts?: any;
  /** @format date-time */
  lockedUntil?: string | null;
}

export interface VirtualCashAccountDto {
  accountNumber?: string | null;
  accountName?: string | null;
  currency?: Currency;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  totalBalance?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  reservedBalance?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  availableBalance?: any;
  /**
   * @format double
   * @pattern ^-?(?:0|[1-9]\d*)(?:\.\d+)?$
   */
  feesPayableBalance?: any;
  /** @format date-time */
  createdDate?: string;
}

export interface WithdrawalAccountDto {
  id?: string | null;
  accountName?: string | null;
  maskedAccountNumber?: string | null;
  maskedIBAN?: string | null;
  sortCode?: string | null;
  bankAddress?: string | null;
  currency?: string | null;
  isVerified?: boolean;
}

import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Preservoir Client API
 * @version 1.0
 * @license MIT
 * @contact API Support
 *
 * Preservoir Client API for Reserve Management.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Account
     * @name AccountRecentTransactionsList
     * @request GET:/api/account/recent-transactions
     * @secure
     */
    accountRecentTransactionsList: (
      query?: {
        CorporateClientId?: string;
        YearMonth?: string;
        /**
         * @format int32
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        PageSize?: any;
        /**
         * @format int32
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        PageNumber?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListOfRecentTransactionDto, any>({
        path: `/api/account/recent-transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountDepositDetailsList
     * @request GET:/api/account/deposit-details
     * @secure
     */
    accountDepositDetailsList: (
      query?: {
        corporateClientId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DepositDetailsDto, any>({
        path: `/api/account/deposit-details`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountWithdrawalAccountsList
     * @request GET:/api/account/withdrawal-accounts
     * @secure
     */
    accountWithdrawalAccountsList: (
      query?: {
        corporateClientId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WithdrawalAccountDto[], any>({
        path: `/api/account/withdrawal-accounts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountWithdrawalsCreate
     * @request POST:/api/account/withdrawals
     * @secure
     */
    accountWithdrawalsCreate: (data: RequestWithdrawalCommand, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/account/withdrawals`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assets
     * @name AssetsTreasuryBillsList
     * @request GET:/api/assets/treasury-bills
     * @secure
     */
    assetsTreasuryBillsList: (
      query?: {
        CorporateEntityId?: string;
        /**
         * @format int32
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        PageNumber?: any;
        /**
         * @format int32
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        PageSize?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListOfTreasuryBillSummaryDto, any>({
        path: `/api/assets/treasury-bills`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assets
     * @name AssetsTreasuryBillsCreate
     * @request POST:/api/assets/treasury-bills
     * @secure
     */
    assetsTreasuryBillsCreate: (data: RequestTreasuryBillCommand, params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/assets/treasury-bills`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assets
     * @name AssetsTreasuryBillsDetail
     * @request GET:/api/assets/treasury-bills/{id}
     * @secure
     */
    assetsTreasuryBillsDetail: (id: string, params: RequestParams = {}) =>
      this.request<TreasuryBillDto, any>({
        path: `/api/assets/treasury-bills/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assets
     * @name AssetsTreasuryBillsSellCreate
     * @request POST:/api/assets/treasury-bills/sell
     * @secure
     */
    assetsTreasuryBillsSellCreate: (
      data: CreateTreasuryBillSellOrderCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/api/assets/treasury-bills/sell`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLoginCreate
     * @request POST:/api/auth/login
     * @secure
     */
    authLoginCreate: (data: LoginUserCommand, params: RequestParams = {}) =>
      this.request<LoginResponse, any>({
        path: `/api/auth/login`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLoginVerifyMfaCreate
     * @request POST:/api/auth/login/verify-mfa
     * @secure
     */
    authLoginVerifyMfaCreate: (data: CompleteMfaLoginCommand, params: RequestParams = {}) =>
      this.request<LoginResponse, any>({
        path: `/api/auth/login/verify-mfa`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLogoutCreate
     * @request POST:/api/auth/logout
     * @secure
     */
    authLogoutCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/logout`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRefreshCreate
     * @request POST:/api/auth/refresh
     * @secure
     */
    authRefreshCreate: (params: RequestParams = {}) =>
      this.request<TokenResult, any>({
        path: `/api/auth/refresh`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSendVerificationCreate
     * @request POST:/api/auth/send-verification
     * @secure
     */
    authSendVerificationCreate: (data: SendVerificationEmailCommand, params: RequestParams = {}) =>
      this.request<SendVerificationEmailResponse, any>({
        path: `/api/auth/send-verification`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRegisterCreate
     * @request POST:/api/auth/register
     * @secure
     */
    authRegisterCreate: (data: RegisterUserAccountCommand, params: RequestParams = {}) =>
      this.request<RegisterUserAccountResponse, any>({
        path: `/api/auth/register`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthVerifyEmailCreate
     * @request POST:/api/auth/verify-email
     * @secure
     */
    authVerifyEmailCreate: (data: VerifyUserAccountEmailCommand, params: RequestParams = {}) =>
      this.request<VerifyUserAccountEmailResponse, any>({
        path: `/api/auth/verify-email`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthResendVerificationCreate
     * @request POST:/api/auth/resend-verification
     * @secure
     */
    authResendVerificationCreate: (
      data: ResendVerificationEmailCommand,
      params: RequestParams = {},
    ) =>
      this.request<ResendVerificationEmailResponse, any>({
        path: `/api/auth/resend-verification`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthForgotPasswordCreate
     * @request POST:/api/auth/forgot-password
     * @secure
     */
    authForgotPasswordCreate: (data: ForgotPasswordCommand, params: RequestParams = {}) =>
      this.request<ForgotPasswordResponse, any>({
        path: `/api/auth/forgot-password`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthResetPasswordCreate
     * @request POST:/api/auth/reset-password
     * @secure
     */
    authResetPasswordCreate: (data: ConfirmPasswordResetCommand, params: RequestParams = {}) =>
      this.request<ResetPasswordResponse, any>({
        path: `/api/auth/reset-password`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthMfaStatusList
     * @request GET:/api/auth/mfa/status
     * @secure
     */
    authMfaStatusList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/mfa/status`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutoRoll
     * @name AutoRollList
     * @request GET:/api/auto-roll
     * @secure
     */
    autoRollList: (
      query?: {
        CorporateEntityId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutoRollInstructionDto[], any>({
        path: `/api/auto-roll`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutoRoll
     * @name AutoRollReconfigureCreate
     * @request POST:/api/auto-roll/{id}/reconfigure
     * @secure
     */
    autoRollReconfigureCreate: (
      id: string,
      data: ReconfigureAutoRollCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/auto-roll/${id}/reconfigure`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutoRoll
     * @name AutoRollCancelCreate
     * @request POST:/api/auto-roll/{id}/cancel
     * @secure
     */
    autoRollCancelCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/auto-roll/${id}/cancel`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CompaniesHouse
     * @name CompaniesHouseSearchList
     * @request GET:/api/companies-house/search
     * @secure
     */
    companiesHouseSearchList: (
      query?: {
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/companies-house/search`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CorporateEntity
     * @name CorporateEntitiesProfileDetail
     * @request GET:/api/corporate-entities/profile/{id}
     * @secure
     */
    corporateEntitiesProfileDetail: (id: string, params: RequestParams = {}) =>
      this.request<CorporateEntityDto, any>({
        path: `/api/corporate-entities/profile/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Market
     * @name MarketTreasuryBillsList
     * @request GET:/api/market/treasury-bills
     * @secure
     */
    marketTreasuryBillsList: (
      query?: {
        /**
         * @format int32
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        PageNumber?: any;
        /**
         * @format int32
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        PageSize?: any;
        MaturityAge?: MaturityAge;
        /** @format date-time */
        ProcessedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListOfTreasuryBillListingDto, any>({
        path: `/api/market/treasury-bills`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projections
     * @name ProjectionsPositionSnapshotsLatestDetail
     * @request GET:/api/projections/position-snapshots/{corporateClientId}/latest
     * @secure
     */
    projectionsPositionSnapshotsLatestDetail: (
      corporateClientId: string,
      query?: {
        /**
         * @format int32
         * @default 1
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        pageNumber?: any;
        /**
         * @format int32
         * @default 10
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        pageSize?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListOfPositionSnapshotDto, any>({
        path: `/api/projections/position-snapshots/${corporateClientId}/latest`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projections
     * @name ProjectionsPositionSnapshotsDetail
     * @request GET:/api/projections/position-snapshots/{corporateClientId}
     * @secure
     */
    projectionsPositionSnapshotsDetail: (
      corporateClientId: string,
      query?: {
        /**
         * @format int32
         * @default 1
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        pageNumber?: any;
        /**
         * @format int32
         * @default 10
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        pageSize?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListOfPositionSnapshotDto, any>({
        path: `/api/projections/position-snapshots/${corporateClientId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projections
     * @name ProjectionsClientBalanceDetail
     * @request GET:/api/projections/client-balance/{corporateClientId}
     * @secure
     */
    projectionsClientBalanceDetail: (corporateClientId: string, params: RequestParams = {}) =>
      this.request<InvestorDailyBalanceDto, any>({
        path: `/api/projections/client-balance/${corporateClientId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projections
     * @name ProjectionsClientFeesDetail
     * @request GET:/api/projections/client-fees/{corporateClientId}
     * @secure
     */
    projectionsClientFeesDetail: (
      corporateClientId: string,
      query?: {
        /** @format date-time */
        dateFrom?: string;
        /** @format date-time */
        dateTo?: string;
        /**
         * @format int32
         * @default 1
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        pageNumber?: any;
        /**
         * @format int32
         * @default 10
         * @pattern ^-?(?:0|[1-9]\d*)$
         */
        pageSize?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListOfClientFeeDto, any>({
        path: `/api/projections/client-fees/${corporateClientId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportsCurrentAssetReportList
     * @request GET:/api/reports/current-asset-report
     * @secure
     */
    reportsCurrentAssetReportList: (
      query?: {
        corporateEntityId?: string;
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/reports/current-asset-report`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportsTaxReportList
     * @request GET:/api/reports/tax-report
     * @secure
     */
    reportsTaxReportList: (
      query?: {
        corporateEntityId?: string;
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/reports/tax-report`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportsTransactionReportList
     * @request GET:/api/reports/transaction-report
     * @secure
     */
    reportsTransactionReportList: (
      query?: {
        corporateEntityId?: string;
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        filterByType?: CashFlowType;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/reports/transaction-report`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Report
     * @name ReportsChargesReportList
     * @request GET:/api/reports/charges-report
     * @secure
     */
    reportsChargesReportList: (
      query?: {
        corporateEntityId?: string;
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        filterByFeeType?: FeeType;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/reports/charges-report`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserProfileList
     * @request GET:/api/user/profile
     * @secure
     */
    userProfileList: (params: RequestParams = {}) =>
      this.request<ProfileWithCorporateEntitiesDto, any>({
        path: `/api/user/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
